/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Rootin 에디터 라이브러리를 정의한다.
 *
 * @file /src/rootin/Rootin.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 9. 6.
 */
import { Editor, Properties as EditorProperties } from '@rootin/core/Editor';
import { Block } from '@rootin/base/Block';
import { Tool } from '@rootin/base/Tool';
import './Rootin.css';

export const Rootin = {
    Editor,
    Block,
    Tool,
};

export namespace Rootin {
    export type Editor = InstanceType<typeof Editor>;
    export type Block = InstanceType<typeof Block>;
    export type Tool = InstanceType<typeof Tool>;
    export type Properties = EditorProperties;
}
